import React from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { FaLeaf, FaUsers, FaHandshake, FaTree, FaChartLine, FaTruck } from 'react-icons/fa';
import { fadeInUp, staggerContainer, enhancedViewport } from '../../utils/animation';
import './AboutStats.scss';

const AboutStats = () => {
  const { t } = useTranslation('about');
  const statsData = t('stats.items', { returnObjects: true });
  
  // OPTIMIZAT: Eliminat useAnimation() și useEffect() overhead - folosim whileInView direct
  const icons = [<FaLeaf />, <FaUsers />, <FaHandshake />, <FaTree />, <FaChartLine />, <FaTruck />];
  
  const stats = statsData.map((stat, index) => ({
    id: index + 1,
    icon: icons[index],
    ...stat
  }));

  return (
    <section className="about-stats">
      <div className="container">
        <motion.div className="about-stats__header">
          <motion.h2 
            className="about-stats__title"
            initial="hidden"
            whileInView="visible"
            viewport={enhancedViewport}
            variants={fadeInUp}
          >
            {t('stats.title')}
          </motion.h2>
          <motion.div 
            className="about-stats__subtitle"
            initial="hidden"
            whileInView="visible"
            viewport={enhancedViewport}
            variants={fadeInUp}
          >
            <p>{t('stats.subtitle')}</p>
          </motion.div>
        </motion.div>
        <motion.div
          className="about-stats__grid"
          variants={staggerContainer}
          initial="hidden"
          whileInView="visible"
          viewport={enhancedViewport}
        >
          {stats.map((stat) => (
            <motion.div 
              className="about-stats__box" 
              key={stat.id}
              variants={fadeInUp}
            >
              <div className="about-stats__icon">{stat.icon}</div>
              <div className="about-stats__content">
                <div className="about-stats__value">{stat.value}</div>
                <div className="about-stats__label">{stat.label}</div>
                <div className="about-stats__description">{stat.description}</div>
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default AboutStats;
